import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import { Controller } from "react-hook-form";
import PlacesAutocomplete, {
    geocodeByAddress,
    getLatLng
  } from "react-places-autocomplete";

// Requires a GOOGLE MAPS API wrapper in the parent component, in order to work
function FormAddressField(props) {
  const { inputRef, inputControl, inputSetValue, inputRules, error } = props;
    const [address, setAddress] = React.useState(""); // 

  const searchOptions = {
    componentRestrictions: { country: "lt" },
    // placeId: "ChIJiaW0VluU3UYR6QNJTUVuxus",
    fields: ["geometry"],
  }

  const handleSelect = async (address) => {
    // setAddress(address);
    await geocodeByAddress(address)
      .then(results => getLatLng(results[0]))
      .then(
        latLng => {
          console.log("latLng: ");
          console.log(latLng);
          props.setCenter && props.setCenter(latLng);
          inputSetValue("lat", latLng.lat);
          inputSetValue("lng", latLng.lng);
          // setCenter(latLng);
      })
      .catch(error => {
          console.error("Error", error)
      });
  };
    
  return (
    <>
        <Controller
            render={({ onChange, value }) => (
            <PlacesAutocomplete
                value={value} // State variable
                onChange={onChange}
                onSelect={async (e) => {
                    // onChange's arg will send value into hook form
                    onChange(e);
                    await handleSelect(e);
                }}
                searchOptions={searchOptions}
            >
                {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                <div className="autocomplete-main-container">
                    <input
                    {...getInputProps({
                        placeholder: 'Automobilio adresas',
                        className: 'form-control form-control-lg location-search-input' + (error ? " is-invalid" : ""),
                    })}
                    />
                    <div className="autocomplete-dropdown-container">
                    {loading && <div>Loading...</div>}
                    {suggestions.map((suggestion, index) => {
                        const className = suggestion.active
                        ? 'suggestion-item--active'
                        : 'suggestion-item';
                        // inline style for demonstration purpose
                        const style = suggestion.active
                        ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                        : { backgroundColor: '#ffffff', cursor: 'pointer' };
                        return (
                        <div
                            {...getSuggestionItemProps(suggestion, {
                            className,
                            style,
                            })}
                            key={"div_" + suggestion.placeId}
                        >
                            <span
                                key={"span_" + suggestion.placeId}
                            >{suggestion.description}</span>
                        </div>
                        );
                    })}
                    </div>
                </div>
                )}
            </PlacesAutocomplete>
            )}
            name={props.inputName}
            control={inputControl}
            rules={inputRules}
            defaultValue={props.defaultValue || address}
        />
        {error && (
            <Form.Control.Feedback type="invalid" className={`"text-left" ${error && " d-block"}`}>
                {error.message}
            </Form.Control.Feedback>
        )}
        <Form.Control 
            type="hidden" 
            name="lat" 
            ref={inputRef}
        />
        <Form.Control 
            type="hidden" 
            name="lng" 
            ref={inputRef}
        />
    </>
  );
}

export default FormAddressField;